/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_JSXRuntime as JSXRuntime,
  rec_MQ as MQ,
  rec_React as React,
  rec_ReactCompiler as ReactCompiler,
} from "../../runtime/index.jsx";
export function RepartoPorArea(e) {
  let t = (0, ReactCompiler.c)(14),
    { orden: n } = e,
    r;
  t[0] === n.reparto
    ? (r = t[1])
    : ((r = n.reparto ?? []), (t[0] = n.reparto), (t[1] = r));
  let i = r;
  if (i.length < 2) return null;
  let a = i[0].total != null,
    o = a ? `Le toca a cada área` : `Si sale, le va a tocar a cada área`,
    s;
  t[2] === o
    ? (s = t[3])
    : ((s = <p className={`mb-1 text-xs text-(--text)`} children={o} />),
      (t[2] = o),
      (t[3] = s));
  let c;
  if (t[4] !== a || t[5] !== i) {
    let e;
    (t[7] === a
      ? (e = t[8])
      : ((e = (e) => (
          <tr
            key={e.area}
            className={`border-t border-(--border)/50 first:border-0`}
            children={[
              <td className={`py-1 pr-2 text-(--text-h)`} children={e.area} />,
              <td
                className={`py-1 pr-2 whitespace-nowrap text-(--text)`}
                children={[
                  e.personas,
                  ` `,
                  e.personas === 1 ? `persona` : `personas`,
                  e.noViajaron > 0 && (
                    <span
                      className={`text-(--error)`}
                      children={[
                        ` · `,
                        e.noViajaron,
                        ` no `,
                        e.noViajaron === 1 ? `viajó` : `viajaron`,
                      ]}
                    />
                  ),
                ]}
              />,
              <td
                className={`py-1 pr-2 whitespace-nowrap text-right text-(--text)`}
                children={[Number(e.porcentaje).toFixed(2), `%`]}
              />,
              <td
                className={`py-1 whitespace-nowrap text-right font-medium text-(--text-h)`}
                children={a ? MQ(e.total) : `—`}
              />,
            ]}
          />
        )),
        (t[7] = a),
        (t[8] = e)),
      (c = i.map(e)),
      (t[4] = a),
      (t[5] = i),
      (t[6] = c));
  } else c = t[6];
  let l;
  t[9] === c
    ? (l = t[10])
    : ((l = (
        <table
          className={`w-full text-left text-xs`}
          children={<tbody children={c} />}
        />
      )),
      (t[9] = c),
      (t[10] = l));
  let u;
  return (
    t[11] !== s || t[12] !== l
      ? ((u = (
          <div
            className={`rounded-xl border border-(--border) p-2`}
            children={[s, l]}
          />
        )),
        (t[11] = s),
        (t[12] = l),
        (t[13] = u))
      : (u = t[13]),
    u
  );
}
